"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getInteractionKeyForLearner(contentId, interactionType, interactingOnId, actorId) {
    return `${contentId}_${interactionType}_${interactingOnId}_${actorId}`;
}
exports.getInteractionKeyForLearner = getInteractionKeyForLearner;
function getInteractionKeyForActorId(contentId, interactionType, interactingOnId, userId) {
    return `${interactionType}_${contentId}_${interactingOnId}_${userId}`;
}
exports.getInteractionKeyForActorId = getInteractionKeyForActorId;
//# sourceMappingURL=getInteractionKey.js.map